export default __webpack_public_path__ + "static/media/plus_white.f42d8944.svg";